import { OptionalMaybe, AddressType } from "../api/types/generated-types";

/**
 * @description Relevant for stops on quote requests with modes AIR or FCL. An address may be a door or a port (or airport).
 * Also see function `isPort`
 * @summary Determines if an address is a "port" (seaport, railhead, or airport)
 */
export const isPort = (type: OptionalMaybe<AddressType>): boolean =>
  type === AddressType.Seaport || type === AddressType.Railhead || type === AddressType.Airport;
